import { ROLE_LABEL_NAMES } from '../constants/roles';

/** Prefer real name; skip values that match role titles; fall back to email local-part. */
export function getUserDisplayName(user) {
  if (!user || typeof user !== 'object') return null;

  const name = user.name?.trim();
  if (name && !ROLE_LABEL_NAMES.has(name)) return name;

  const email = user.email?.trim();
  if (email) {
    const local = email.split('@')[0];
    return local
      .replace(/[._-]+/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }

  return name || null;
}
